import { NumericType, TimeType } from "src/AngularJS/Models/metric";
import { ClearViewUtils } from "../utils";

export class ModuleHelperServiceBase {

    constructor() { }

    static getServiceBase(): ModuleHelperServiceBase {
        return ClearViewUtils.getSharedService(ModuleHelperServiceBase, 'ModuleHelperServiceBase');
    }

    /**
     *  Formats a metric in a similar fashion to the back-end
     *  DO NOT USE UNLESS ABSOLUTELY NECESSARY - THE BEST WAY TO HAVE FORMATTED DATA IS THROUGH MetricData.MetricDisplayValue
     *
     * @param metricValue The double value that will be formatted
     * @param metricNumericType The NumericType ( 0 = Currency, 1 =Number, 2 = Percent, 3 = Time) of the metric
     * @param metricTimeType The TimeType (0 = None, 1 = Second, 2 = Minute, 3 = Hour, 4 = Time) of the metric
     */
    public formatMetricValue(metricValue: number, metricNumericType: NumericType = NumericType.Number, metricTimeType: TimeType = TimeType.None): string {
        // format value using js Number locale functions
        const metricNumber = Number(metricValue);
        switch (metricNumericType) {
            case 0: // Currency
                return metricNumber.toLocaleString(CVCultureName, {
                    style: 'currency',
                    currency: CVISOCurrencySymbol,
                    maximumFractionDigits: 2,
                });
            case 1: // Number
                return metricNumber.toLocaleString(CVCultureName, {
                    maximumFractionDigits: 2,
                });
            case 2: // Percent
                return metricNumber.toLocaleString(CVCultureName, {
                    style: 'percent',
                    maximumFractionDigits: 2,
                });
            case 3: // Time
                switch (metricTimeType) {
                    case 4: // time
                        const hours = Math.floor(metricValue / 3600);
                        const minutes = Math.floor((metricValue - (hours * 3600)) / 60);
                        const seconds = Math.floor(metricValue - (hours * 3600) - (minutes * 60));

                        // zero padding
                        let hoursStr = '' + hours;
                        let minutesStr = '' + minutes;
                        let secondsStr = '' + seconds;
                        let formattedStr = '';

                        if (hours < 10) {
                            hoursStr = '0' + hours;
                        } else { // no zero-pad, but format as a number in case the number is large enough to have seperators
                            hoursStr = Number(hours).toLocaleString(CVCultureName);
                        }
                        if (minutes < 10) minutesStr = '0' + minutes;
                        if (seconds < 10) secondsStr = '0' + seconds;

                        // hh?:mm:ss
                        formattedStr = minutesStr + ':' + secondsStr;
                        // if (hours !== 0) {
                        formattedStr = hoursStr + ':' + formattedStr;
                        // }

                        return formattedStr;
                    default: // 0 (none) or 1 (second) or 2 (minute) or 3 (hour)
                        return metricNumber.toLocaleString(CVCultureName, {
                            maximumFractionDigits: 2,
                        });
                }
            default: // value not in enum, just format as number
                return metricNumber.toLocaleString(CVCultureName, {
                    maximumFractionDigits: 2,
                });
        }
    }
}
